import React from "react";

const Cards = ({ dashdata }) => {
  return (
    <div className="stat-row">
      <div className="stat-card">
        <div className="stat-icon" style={{ background: "var(--green-soft)" }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#17B26A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
        </div>
        <div>
          <div className="val">{dashdata.total_calls}</div>
          <div className="lbl">Total Calls</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: "var(--pink-soft)" }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#F0508B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </div>
        <div>
          <div className="val">{dashdata.answerd_calls}</div>
          <div className="lbl">Answered Calls</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: "var(--amber-soft)" }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#7C6FEF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <div>
          <div className="val">{dashdata.call_duration}</div>
          <div className="lbl">Total Talk Time</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon" style={{ background: "var(--primary-soft)" }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#2F6FED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 8v4l3 3" />
            <circle cx="12" cy="12" r="9" />
          </svg>
        </div>
        <div>
          <div className="val">{dashdata.followup_calls_count}</div>
          <div className="lbl">Follow-ups Due Today</div>
        </div>
      </div>
    </div>
  );
};

export default Cards;
